import { render, staticRenderFns } from "./VersionDetails.vue?vue&type=template&id=31075400&scoped=true"
import script from "./VersionDetails.vue?vue&type=script&lang=js"
export * from "./VersionDetails.vue?vue&type=script&lang=js"
import style0 from "./VersionDetails.vue?vue&type=style&index=0&id=31075400&prod&lang=css"
import style1 from "./VersionDetails.vue?vue&type=style&index=1&id=31075400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31075400",
  null
  
)

export default component.exports